/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModuleMetadata } from './courseModuleMetadata';
import type { CourseModuleCourses } from './courseModuleCourses';
import type { CourseModuleAuthor } from './courseModuleAuthor';
import type { ModuleState } from './moduleState';
import type { CourseModuleGrading } from './courseModuleGrading';
import type { CourseModuleGradingConfigSnapshot } from './courseModuleGradingConfigSnapshot';
import type { CourseModuleImageUrl } from './courseModuleImageUrl';
import type { CourseModuleIsDeprecated } from './courseModuleIsDeprecated';
import type { CourseModuleMandates } from './courseModuleMandates';
import type { CourseModuleUpgradeOffer } from './courseModuleUpgradeOffer';
import type { CourseModuleExamAttempt } from './courseModuleExamAttempt';
import type { CourseModuleCourseSettings } from './courseModuleCourseSettings';

/**
 * Module that is part of a course with its course-specific settings (for admins)
 */
export interface CourseModule {
  id: string;
  version?: string;
  title: string;
  metadata: CourseModuleMetadata;
  /** DEPRECATED: Do not use for navigation. List of courses this module belongs to. */
  courses?: CourseModuleCourses;
  author?: CourseModuleAuthor;
  state: ModuleState;
  grading?: CourseModuleGrading;
  gradingConfigSnapshot?: CourseModuleGradingConfigSnapshot;
  imageUrl?: CourseModuleImageUrl;
  isDeprecated?: CourseModuleIsDeprecated;
  mandates?: CourseModuleMandates;
  upgradeOffer?: CourseModuleUpgradeOffer;
  examAttempt?: CourseModuleExamAttempt;
  courseSettings?: CourseModuleCourseSettings;
}
